import type { RouteRecordRaw } from "vue-router";

export default {
  path: "pending-requests",

  children: [
    {
      path: "",
      name: "pending.requests",
      component: () => import("@/modules/pendingRequests/pages/IndexPage.vue"),
    },
    {
      path: ":id",
      name: "pending.requests.show",
      component: () => import("@/modules/pendingRequests/pages/ShowPage.vue"),
      },
  ],
} as RouteRecordRaw;
